import { useTheme } from "../context/ThemeContext";

export default function Badge({ status }) {
  const { mode } = useTheme();
  const map = {
    active:   ["var(--green)", "var(--green-bg)", "var(--green-border)"],
    online:   ["var(--green)", "var(--green-bg)", "var(--green-border)"],
    complete: ["var(--green)", "var(--green-bg)", "var(--green-border)"],
    info:     ["var(--blue)",  "var(--blue-bg)",  "var(--blue-border)"],
    degraded: ["var(--amber)", "var(--amber-bg)", "var(--amber-border)"],
    warning:  ["var(--amber)", "var(--amber-bg)", "var(--amber-border)"],
    pending:  ["var(--amber)", "var(--amber-bg)", "var(--amber-border)"],
    inactive: ["var(--grey)",  "var(--grey-bg)",  "var(--grey-border)"],
    offline:  ["var(--grey)",  "var(--grey-bg)",  "var(--grey-border)"],
    error:    ["var(--red)",   "var(--red-bg)",   "var(--red-border)"],
    archived: ["var(--amber)", "var(--amber-bg)", "var(--amber-border)"],
  };
  const [color, bg, border] = map[status] || ["var(--grey)", "var(--grey-bg)", "var(--grey-border)"];
  return (
    <span style={{ display:"inline-flex", alignItems:"center", gap:5, background:bg, color, border:`1px solid ${border}`, borderRadius:4, padding:"2px 7px", fontSize:11, fontWeight:600, letterSpacing:"0.03em", textTransform:"uppercase", whiteSpace:"nowrap" }}>
      <span style={{ width:5, height:5, borderRadius:"50%", background:color, flexShrink:0 }} />
      {status}
    </span>
  );
}
